import {
  setUpLoginButtons,
  setUpMobileHamburgerMenu,
} from 'js/simple_layout/header/setUpHeader';

setUpMobileHamburgerMenu();
setUpLoginButtons({ pageName: 'landing' });

document.addEventListener('DOMContentLoaded', () => {
  // visibility adjustments for fixed elements that follow user after scrolling down past header area
  const floater = document.querySelector('.js-landing-floater') as Element;
  const stickyActionsTrigger = document.querySelector(
    '.js-sticky-actions-trigger',
  ) as Element;
  document.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => {
      if (stickyActionsTrigger.getBoundingClientRect().top < 0) {
        floater.classList.remove('hidden');
      } else {
        floater.classList.add('hidden');
      }
    });
  });
});
